export var getValueOfNestedObject = function (object, path, defaultValue) {
    if (object === undefined || object === null || path === undefined || path === null) {
        return defaultValue;
    }
    var names = path.split('.');
    names = names === null || names === void 0 ? void 0 : names.flatMap(function (name) {
        return name.includes('[') && name.includes(']')
            ? [name.split('[')[0], parseInt(name.split('[')[1])]
            : [name];
    }).reverse();
    while (names.length && (object = object[names.pop()]) !== undefined && object != null)
        ;
    if (object === null && names.length)
        object = undefined;
    return object === undefined ? defaultValue : object;
};
